import React, { useState } from "react";
import { Button, Modal, Form, Dropdown } from "semantic-ui-react";
import { useForm } from "../util/hooks";
import { useMutation } from "@apollo/react-hooks";
import { ADD_PLAYER } from "../util/graphql";
import { positionOptions } from "../variables/TableManipulation.js";
// import { FETCH_TEAM_QUERY } from "../util/graphql";

function AddModal(props) {
  const [open, setOpen] = React.useState(false);
  const [errors] = useState({});

  const { onChange, handleDropdownChange, onSubmit, values } = useForm(
    addPlayerCallback,
    {
      name: "",
      pos: "",
      org: "",
      salary: "",
      contract: "",
    }
  );

  const [addPlayer] = useMutation(ADD_PLAYER, {
    variables: values,
    update(proxy, result) {
      // const data = proxy.readQuery({
      //   query: FETCH_TEAM_QUERY,
      // });
      // data.getTeam = [result.data.addPlayer, ...data.getTeam];
      // proxy.writeQuery({ query: FETCH_TEAM_QUERY, data });
      values.name = "";
      values.pos = "";
      values.org = "";
      values.salary = "";
      values.contract = "";
      window.location.reload(false);
    },
  });

  function addPlayerCallback() {
    addPlayer();
  }

  return (
    <Modal
      as={Form}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={
        <Button positive>
          Add Player
          {/* <Icon name="add" /> */}
        </Button>
      }
    >
      <Modal.Header>Add Player to Your Team</Modal.Header>
      <Modal.Content style={{ width: "75%" }}>
        <Form.Input
          label="Name"
          placeholder="Name.."
          name="name"
          type="text"
          value={values.name}
          error={errors.name ? true : false}
          onChange={onChange}
        />
        <Form.Field
          control={Dropdown}
          fluid
          selection
          label="Position"
          name="pos"
          placeholder="Position"
          options={positionOptions}
          defaultValue={values.pos}
          value={values.pos}
          error={errors.pos ? true : false}
          onChange={handleDropdownChange}
        />
        {/* <Dropdown
          label="Position"
          placeholder="Example: C, 1B, 2B, OF, BN(ONLY HITTERS), SP, RP, P(BENCH PITCHERS)"
          name="pos"
          type="pos"
          options={[{ key: "angular", text: "Angular", value: "angular" }]}
          value={values.pos}
          error={errors.pos ? true : false}
          onChange={onChange}
        /> */}
        <Form.Input
          label="Org"
          placeholder="Team..."
          name="org"
          type="org"
          value={values.org}
          error={errors.org ? true : false}
          onChange={onChange}
        />
        <Form.Input
          label="Salary"
          placeholder="Example: 1.0M, .5 Million, 15M"
          name="salary"
          type="salary"
          value={values.salary}
          error={errors.salary ? true : false}
          onChange={onChange}
        />
        <Form.Input
          label="Contract"
          placeholder="End date of contract or what year of cost control schedule"
          name="contract"
          type="contract"
          value={values.contract}
          error={errors.contract ? true : false}
          onChange={onChange}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)}>Cancel</Button>
        <Button type="submit" onClick={onSubmit} positive>
          Add
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default AddModal;
